import InstantBooking from "@Icons/InstantBooking";
import PriceMatchGuaranteeIcon from "@Icons/PriceMatchGuaranteeIcon";
import VerifiedIcon from "@Icons/VerifiedIcon";

export const data = [
  {
    icon: <VerifiedIcon />,
    boldText: "100%",
    text: "Verified Listings",
  },
  {
    icon: <InstantBooking />,
    boldText: "Quick and Easy",
    text: "Bookings",
  },
  {
    icon: <PriceMatchGuaranteeIcon />,
    boldText: "Price Match",
    text: "Guarantee",
  },
  {
    icon: <InstantBooking />,
    boldText: "24x7",
    text: "Personal Assistance",
  },
];

export const backgroundImageUrl =
  "https://prod-static-assets.amberstudent.com/images/qrBackground.png";
